import { render, staticRenderFns } from "./UploadBulkPromotion.vue?vue&type=template&id=1c309f34"
import script from "./UploadBulkPromotion.vue?vue&type=script&lang=js"
export * from "./UploadBulkPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports